﻿'use strict';

/** 
 * Controller for data rights configuration 
 * @memberOf components.dataRights
 * @namespace dataRightsController
 */

dataRightsController.$inject = ['connectionsFactory', 'data_project_constants'];

function dataRightsController(connectionsFactory, data_project_constants) {
    var vm = this;

    vm.apiConnection = connectionsFactory.getApplicationAPIConnection(data_project_constants.endpoints.application_api);
    vm.dataRightsConnection = vm.apiConnection.all('dataRights');

    vm.updateState = {
        status: '',
        isError: false
    };

    vm.dataRights = [];

    vm.resetUpdateState = function () {
        vm.updateState.status = '';
        vm.updateState.isError = false;
    }

    vm.onDataRightsClick = function (clickedConfig) {
        vm.resetUpdateState();

        clickedConfig.dataRights = !clickedConfig.dataRights;
        clickedConfig.dataRightsModified = !clickedConfig.dataRightsModified;
    };

    vm.onReviewedClick = function (clickedConfig) {
        vm.resetUpdateState();

        clickedConfig.needsReview = !clickedConfig.needsReview;
        clickedConfig.reviewed = !clickedConfig.reviewed;
    }

    vm.getModifiedDataRights = function (dataRights) {
        return dataRights.filter(function (element) {
            return element.dataRightsModified || element.reviewed;
        }).map(function (element) {

            if (element.reviewed) {
                if (element.status == 'New' || element.status == 'Returning' || element.status == 'Active') {
                    element.status = 'Active';
                }
            }

            return _.omit(element, ['dataRightsModified', 'reviewed']);
        })
    };

    vm.updateDataRights = function () {

        var modifiedDataRights = vm.getModifiedDataRights(vm.dataRights);

        if (modifiedDataRights.length > 0) {
            vm.dataRightsConnection
                .customPOST(modifiedDataRights, undefined, undefined, { 'Content-Type': 'application/json' })
                .then(function (data) {
                    if (data.requestCount == data.modifiedCount) {
                        vm.updateState.status = "Update Succeeded!";
                        vm.updateState.isError = false;

                        vm.resetModifedAndReviewed();
                    }
                    else {
                        vm.updateState.status = "Error updating...";
                        vm.updateState.isError = true;
                    } 
                },
                function (result) {
                    vm.updateState.status = "Error updating...";
                    vm.updateState.isError = true;
                });
        }
    };

    vm.resetModifedAndReviewed = function () {
        vm.dataRights.forEach(function (element) {
            element.reviewed = false;
            element.dataRightsModified = false;
        });
    }

    vm.$onInit = function () {
        vm.dataRightsConnection
            .customGET()
            .then(function (result) {
                var dataRights = result.plain().dataRights.filter(function (obj) {
                    return obj.status !== 'Retired';
                });

                dataRights.forEach(function (element) {
                    element.dataRightsModified = false;
                    element.reviewed = false; 
                });

                vm.dataRights = dataRights;
            });
    };
}

module.exports = dataRightsController;


//////////////////
// WEBPACK FOOTER
// ./source/angular/components/admin/dataRightsController.js
// module id = 33
// module chunks = 0